import { render, staticRenderFns } from "./CreateEditNotification.vue?vue&type=template&id=1180df74&scoped=true&"
import script from "./CreateEditNotification.vue?vue&type=script&lang=ts&"
export * from "./CreateEditNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditNotification.vue?vue&type=style&index=0&id=1180df74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180df74",
  null
  
)

export default component.exports